import {
  DocumentFileDeactivationDialogComponent,
  DocumentFileDeativationDialogData,
} from '../components/document-file-deactivation-dialog/document-file-deactivation-dialog.component';
import {
  AbstractFileDialogsManagerService,
  ApplicationConfigService,
  CounterTypeGroup,
  MainMenuCountsService
} from '|shared';
import {FileDto} from '|api/document';
import {Observable, tap} from 'rxjs';
import {FileSettleDialogComponent} from '../components/file-settle-dialog/file-settle-dialog.component';
import {FileCloseDialogComponent} from '../components/file-close-dialog/file-close-dialog.component';
import {inject, Injectable} from '@angular/core';
import {IczModalService, IczModalSizeClass} from '@icz/angular-modal';

@Injectable()
export class FileDialogsManagerService implements AbstractFileDialogsManagerService {

  private modalService = inject(IczModalService);
  private mainMenuCountsService = inject(MainMenuCountsService);
  private applicationConfigService = inject(ApplicationConfigService);

  openDeactivationDialog(fileData: FileDto): Observable<Nullable<boolean>> {
    return this.modalService.openComponentInModal<boolean, DocumentFileDeativationDialogData>({
      component: DocumentFileDeactivationDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_800_600,
        titleTemplate: 'Zrušení spisu',
      },
      data: {
        isDocument: false,
        subject: fileData.subject,
        entityId: fileData.id,
      },
    });
  }

  openFileSettleDialog(fileData: FileDto[]): Observable<Nullable<boolean>> {
    let titleTemplate: string;
    if (this.applicationConfigService.closeFileWithSettlement()) {
      titleTemplate = fileData.length > 1 ? 'Vyřízení a uzavření spisů ({{count}})' : 'Vyřízení a uzavření spisu {{refNumber}}';
    } else {
      titleTemplate = fileData.length > 1 ? 'Vyřízení spisů ({{count}})' : 'Vyřízení spisu {{refNumber}}';
    }

    return this.modalService
      .openComponentInModal<boolean, FileDto[]>({
        component: FileSettleDialogComponent,
        modalOptions: {
          sizeClass: IczModalSizeClass.WH_RESPONSIVE,
          titleTemplate,
          titleTemplateContext: {
            refNumber: fileData[0].refNumber || '',
            count: String(fileData.length),
          },
          disableAutoMargin: true,
        },
        data: fileData,
      });
  }

  openFileCloseDialog(fileData: FileDto[]): Observable<Nullable<boolean>> {
    return this.modalService.openComponentInModal<boolean, FileDto[]>({
      component: FileCloseDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_RESPONSIVE,
        titleTemplate: fileData.length > 1 ? 'Uzavření spisů ({{count}})' : 'Uzavření spisu {{fileSubject}}',
        titleTemplateContext: {
          fileSubject: fileData[0].subject,
          count: String(fileData.length),
        },
        disableAutoMargin: true,
      },
      data: fileData,
    }).pipe(
      tap(result => {
        if (result) {
          this.mainMenuCountsService.updateMainMenuCounters([CounterTypeGroup.DOCUMENT_FILE_TASKS_RECEIVED_CONSIGNMENTS_TRANSFERS_COUNTS]);
        }
      })
    );
  }

}
